// ── 모바일 스타일 인덱스 ──────────────────────────────────────────────────────
// mobileStylesBase + mobileStylesDetail을 단일 s 객체로 병합하여 재출력

import * as base   from './mobileStylesBase';
import * as detail from './mobileStylesDetail';

/** 모바일 전체 스타일 객체 (컴포넌트에서 s.xxx 형태로 사용) */
export const s = { ...base, ...detail };
